import { observer } from 'mobx-react';
import React from 'react';
import Grid from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';
import { PracticeReport } from '../../types/practice-types';

interface UpgradeReportsModalProps {
  reports: PracticeReport[];
}

const UpgradeReportsModalContent = observer((props: UpgradeReportsModalProps) => {
  const store = useStore().upgradeManagementStore;
  const { reportsColDefs } = store;

  return <Grid id='upgrade-reports-grid' columns={reportsColDefs} data={props.reports} />;
});

export default UpgradeReportsModalContent;
